import React from "react";
import logo from "../../assets/img/logo.svg";

import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


const DetailsMission = ({
  mode = "entreprise", // "entreprise" ou "particulier"
  particulierStatus, // "proposition", "encours", "demande", ou "offre"
  onAccept,
  onRefuse,
  onBack,
  onDashboard,
  onSendRequest // Utilisé quand particulierStatus === "offre"
}) => {
  const missionDetails = {
    hotelName: "Hotel fontaine",
    role: "Receptioniste",
    address: "15 adresse postale 06000 Nice",
    importantInfo: ["Tenue correcte exigée", "Permis B exigé"],
    hourlyRate: "11.09 €",
    estimatedGrossSalary: "72.80 €",
    startDate: "Mer. 14 Mars 2025",
    startTime: "09h00",
    endDate: "Ven. 16 Mars 2025",
    endTime: "15h00",
    workedDays: "2 jours",
    workedHours: "06.00",
    mapLink: "#",
    position: [43.694915, 7.255006]
  };


  const mapZoom = 16;

  // === HANDLERS ===
  // Handlers internes avec console.log (si non fournis en props)
  const handleAccept = () => {
    if (onAccept) return onAccept();
    console.log("Accepter la mission (TODO: appel API)");
  };
  const handleRefuse = () => {
    if (onRefuse) return onRefuse();
    console.log("Refuser la mission (TODO: appel API)");
  };
  const handleBack = () => {
    if (onBack) return onBack();
    console.log("Retour (TODO: navigation)");
  };
  const handleDashboard = () => {
    if (onDashboard) return onDashboard();
    console.log("Revenir au dashboard (TODO: navigation)");
  };
  const handleCancelMission = () => {
    console.log("Annuler la mission (TODO: appel API)");
  };
  const handleViewMap = () => {
    console.log("Voir la carte (TODO: navigation vers Maps)");
  };
  const handleSendRequest = () => {
    if (onSendRequest) return onSendRequest();
    console.log("Envoyer une demande (TODO: appel API)");
  };


  // Déterminer le titre en fonction du mode et du statut particulier
  const getTitle = () => {
    if (mode === "particulier" && particulierStatus === "offre") {
      return "Offres d'emplois";
    }
    // Pour proposition/encours, le titre est géré par les boutons Retour/Dashboard
    if (mode === "particulier" && (particulierStatus === "proposition" || particulierStatus === "encours")) {
      return null;
    }
    // Mode entreprise ou autre cas particulier non géré spécifiquement
    return "Détail de la mission";
  };

  const title = getTitle();

  return (
    <section className="md-details-section">
      <div className="md-header-actions-row">
        <div className="md-header-col-left">
          <div className="md-header-action-left">
            {/* Boutons spécifiques pour particulier proposition/encours */}
            {mode === "particulier" && particulierStatus === "proposition" ? (
              <button className="btn outline md-back-dashboard" onClick={handleDashboard}>
                Revenir au tableau de bord
              </button>
            ) : mode === "particulier" && particulierStatus === "encours" ? (
              <button className="btn outline md-back-dashboard" onClick={handleBack}>
                Retour
              </button>
            ) : title ? ( // Afficher le titre pour entreprise et particulier "offre"
              <h2 className="md-section-title">{title}</h2>
            ) : null}
          </div>
        </div>

        <div className="md-header-col-right">
          {/* Boutons Accepter/Refuser uniquement pour particulier "proposition" */}
          {mode === 'particulier' && particulierStatus === 'proposition' && (
            <div className="md-action-buttons-right">
              <button className="btn md-accept" onClick={handleAccept}>Accepter la mission</button>
              <button className="btn outline md-refuse" onClick={handleRefuse}>Refuser</button>
            </div>
          )}
        </div>
      </div>
      <div className="md-content-wrapper">
        {/* Carte de gauche : Infos mission */}
        <div className="md-info-card">
          <div className="md-card-header">
            <div className="md-logo">
              <img src={logo} alt="Logo" className="md-logo-img" />
            </div>
            <div className="md-hotel-info">
              <h3>{missionDetails.hotelName}</h3>
              <p>{missionDetails.role}</p>
            </div>
            {mode === "particulier" && (particulierStatus === 'proposition' || particulierStatus === 'encours') && (
              <div className="md-status-badge md-status-badge-right">
                {particulierStatus === "proposition" ? (
                  <span className="md-badge md-badge-proposition">PROPOSITION</span>
                ) : (
                  <span className="md-badge md-badge-encours">En cours</span>
                )}
              </div>
            )}
          </div>

          <div className="md-info-row">
            <span className="md-info-label">Adresse postale</span>
            <span className="md-info-value address">{missionDetails.address}</span>
          </div>

          <div className="md-info-row">
            <span className="md-info-label">Informations importante</span>
            <div className="md-important-info">
              {missionDetails.importantInfo.map((info, index) => (
                <span key={index} className="md-info-value important">{info}</span>
              ))}
            </div>
          </div>

          <div className="md-info-row">
            <span className="md-info-label">Taux horaire brut</span>
            <span className="md-info-value rate">{missionDetails.hourlyRate}</span>
          </div>

          <div className="md-info-row">
            <span className="md-info-label">Salaire brut prévisionnel</span>
            <span className="md-info-value salary">{missionDetails.estimatedGrossSalary}</span>
          </div>
        </div>

        {/* Carte de droite : Planning, Carte, Actions */}
        <div className="md-schedule-map-card">
          <div className="md-schedule-row">
            {/* Bloc Début de la mission */}
            <div className="md-schedule-block md-schedule-block-start">
              <span className="md-schedule-label">Début de la mission</span>
              <span className="md-schedule-datetime date">{missionDetails.startDate}</span>
              <span className="md-schedule-datetime time">{missionDetails.startTime}</span>
            </div>

            {/* Bloc Fin de mission */}
            <div className="md-schedule-block md-schedule-block-end">
              <span className="md-schedule-label">Fin de la mission</span>
              <span className="md-schedule-datetime date">{missionDetails.endDate}</span>
              <span className="md-schedule-datetime time">{missionDetails.endTime}</span>
            </div>
          </div>

          {/* Bloc Jours travaillés et heures */}
          <div className="md-worked-info">
            <span className="md-worked-summary">Jours travaillés : {missionDetails.workedDays}</span>
            <span className="md-worked-details">{missionDetails.startTime}</span>
            <span className="md-worked-details md-worked-hours">Heure travaillées : {missionDetails.workedHours} heures</span>
          </div>

          <div className="md-map-placeholder">

            <MapContainer center={missionDetails.position} zoom={mapZoom} scrollWheelZoom={false} className="md-map-content">
                <TileLayer
                    url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                />
                <Marker position={missionDetails.position}>
                    <Popup>
                        {missionDetails.hotelName} <br /> {missionDetails.address}
                    </Popup>
                </Marker>
            </MapContainer>
          </div>

          {/* Bouton Annuler (entreprise) ou Envoyer demande (particulier offre) */}
          {mode === "entreprise" && (
            <button className="btn outline md-cancel-button" onClick={handleCancelMission}>
              Annuler la mission
            </button>
          )}
          {mode === "particulier" && particulierStatus === "offre" && (
            <button className="btn fill green md-send-request-button" onClick={handleSendRequest}>
              Envoyer une demande
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default DetailsMission;